/* yta-cart-boost：湊免運加購按鈕，加入後重新渲染購物車抽屜 */
(function () {
  if (window.ytaCartBoostBound) return;
  window.ytaCartBoostBound = true;

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-yta-addon]');
    if (!btn || btn.disabled) return;
    event.preventDefault();

    var label = btn.textContent;
    btn.disabled = true;

    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json(); })
      .then(function (state) {
        if (state.status) {
          btn.disabled = false;
          btn.textContent = label;
          var errors = document.getElementById('CartDrawer-CartErrors');
          if (errors) errors.textContent = state.description || state.message || '';
          return;
        }
        if (drawer && state.sections) {
          drawer.renderContents(state);
        } else {
          window.location = window.routes.cart_url;
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
      });
  });
})();
